<template>
  <div>
    <el-form
      ref="form" :rules="rules" :model="form"
      @submit.prevent.native="submit">
      <el-form-item prop="email" :label="$t('shopSignInPage.emailLabel')">
        <el-input
          v-model="form.email"
          data-test="email-input"
          :placeholder="$t('shopSignInPage.emailLabel')">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          v-loading="loading"
          data-test="submit-button"
          type="success" style="width: 100%;"
          @click="submit">
          {{ $t('shopSignInPage.submitButtonText') }}
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>
<script>
import services from 'services';

export default {
  data() {
    return {
      loading: false,
      rules: {
        email: [
          {
            required: true,
            message: this.$t('shopSignInPage.validEmailRequiredMessage'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('shopSignInPage.validEmailRequiredMessage'),
            trigger: ['blur', 'change'],
          },
        ],
      },
      form: {
        email: '',
      },
    };
  },
  methods: {
    async sendMagicLink(email) {
      try {
        this.loading = true;
        await services.shopAuthService.sendMagicLink(email);
        this.showSuccessMessage();
      } catch (e) {
        this.showDefaultErrorMessage();
      }
      this.loading = false;
    },
    showSuccessMessage() {
      this.$message.success({ message: this.$t('shopSignInPage.successMessage') });
    },
    showDefaultErrorMessage() {
      this.$message.error({ message: this.$t('commons.defaultErrorMessage') });
    },
    submit(e) {
      console.log('PREVENT');
      e.preventDefault();
      this.$refs.form.validate((valid) => {
        if (!valid) { return; }
        this.sendMagicLink(this.form.email);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
</style>
